// extracted by mini-css-extract-plugin
export default {"container":"Brand_container__slNFX","addBrand":"Brand_addBrand__+mp-9"};